import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { observer , inject } from 'mobx-react';
import DocumentTitle from 'react-document-title';
import './Home.css';
import Logo from './24hf-long.png'
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { setDigitalData } from '../../Utilities/Utils.js';

class DGRHome extends Component {

    componentWillMount(){
        this.props.DGRStore.clearValues()
    }
    componentDidMount(){
        this.props.DGRBackgroundStore.hideBlurAndHeader()
        ReactGA.ga('send', 'pageview', {'sessionControl': 'end', 'nonInteraction': true});
        ReactGA.set({ dimension1: this.props.DGRStore.club_number });
        ReactGA.set({ dimension2: this.props.DGRStore.clubValues.name });
        ReactGA.set({ dimension7: new Date().getTime() });

        setDigitalData( 'welcome page', this.props.DGRStore.club_number );
    }

    guestRegisterClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Welcome',
            action: 'Guest Registration'
        });
    }

    readyJoinClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Welcome',
            action: 'Ready to Join'
        });
    }

    memberLoginClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Welcome',
            action: 'Member Login'
        });
    }

    render(){
        const { name } = this.props.DGRStore.clubValues
        return (
            <Fade>
            <div className="home">
                <img alt="" className="logo" src={Logo}/>
                <div className="homeTitle">
                    <h3>Welcome to {name}</h3>
                </div>
                <div className="homeSubTitle">
                    <p>Choose an option to get started:</p>
                </div>
                <DocumentTitle title='24 Hour Fitness' onClick={ this.guestRegisterClicked }></DocumentTitle>
                <Link to="/enter_pass" tabIndex="-1">
                    <button className="bigButton">Guest Registration</button>
                </Link>
                <Link to="/join" tabIndex="-1" onClick={ this.readyJoinClicked }>
                    <button className="bigButton"> I&rsquo;m Ready to Join</button>
                </Link>
                <Link to="/member/menu" className="memberlogin" tabIndex="-1" onClick={ this.memberLoginClicked }>
                    I&rsquo;m already a member
                </Link>
            </div>
            </Fade>
        )
        }
}

DGRHome = inject('DGRBackgroundStore','DGRStore')(observer(DGRHome))
export default DGRHome



// WEBPACK FOOTER //
// ./src/components/DGR/Home/Home.js